// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"a136d4f0","453":"b28f2a56","934":"d8484066"}[chunkId] + ".chunk.js";
};